export default __webpack_public_path__ + "static/bg-souloflion-3b1cee87edfaeaf49b6f9ff4f00c2523.png";